import type {
  PutDocumentsSignaturePositionRequestType,
  PutDocumentsSignaturePositionResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const putDocumentsSignaturePosition = async ({
  documentId,
  ...body
}: PutDocumentsSignaturePositionRequestType) => {
  const url = `/api/v2/documents/${documentId}/signature/position`;
  return apiAuthClient.put<PutDocumentsSignaturePositionResponseType>(url, {
    ...body,
    x: body.x !== undefined ? Math.round(body.x) : undefined,
    y: body.y !== undefined ? Math.round(body.y) : undefined,
  });
};
